import React, { useState } from "react";
import "./Contact.css";

// ─── WhatsApp target number (modify as needed) ───────────────────────────────
const WHATSAPP_NUMBER = "919495958871"; // without '+' or spaces

// ─── Contact info items ───────────────────────────────────────────────────────
const CONTACT_ITEMS = [
  {
    id: "location",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
    ),
    label: "Our Location",
    value:
      "13/656 'R', New Industrial Development Area, Kanjikode, Palakkad, Kerala, India",
    href: null,
  },
  {
    id: "phone",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .82h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
      </svg>
    ),
    label: "Phone Number",
    value: "+91 9249535060  ·  +91 9495958871",
    href: "tel:+919249535060",
  },
  // {
  //   id: "mobile",
  //   icon: (
  //     <svg
  //       width="20"
  //       height="20"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="1.8"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
  //       <line
  //         x1="12"
  //         y1="18"
  //         x2="12.01"
  //         y2="18"
  //         strokeWidth="2.5"
  //         strokeLinecap="round"
  //       />
  //     </svg>
  //   ),
  //   label: "Mobile",
  //   value: "+91 94959 58871  ·  +91 79070 99782",
  //   href: "tel:+919495958871",
  // },
  {
    id: "email",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
    label: "Email Address",
    value: "sales@emmark.in",
    href: "mailto:sales@emmark.in",
  },
  {
    id: "website",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
      </svg>
    ),
    label: "Website",
    value: "arklonlapspool.com",
    href: "https://www.arklonlapspool.com",
  },
  {
    id: "hours",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12,6 12,12 16,14" />
      </svg>
    ),
    label: "Business Hours",
    value: "Mon – Sat: 9:00 AM – 6:00 PM",
    href: null,
  },
];

// ─── Subject options ──────────────────────────────────────────────────────────
const SUBJECTS = [
  { value: "", label: "Select a subject" },
  { value: "quote", label: "Request a Quote" },
  { value: "product", label: "Product Inquiry" },
  { value: "support", label: "Technical Support" },
  { value: "partnership", label: "Business Partnership" },
  { value: "other", label: "Other" },
];

// ─── Empty form state ─────────────────────────────────────────────────────────
const EMPTY_FORM = {
  name: "",
  email: "",
  phone: "",
  company: "",
  subject: "",
  message: "",
};

// ─── Helper: build WhatsApp message from form data ───────────────────────────
const buildWhatsAppMessage = (form) => {
  const subjectLabel =
    SUBJECTS.find((s) => s.value === form.subject)?.label || form.subject;

  let message = `*New Contact Form Submission*%0A%0A`;
  message += `*Name:* ${form.name}%0A`;
  message += `*Email:* ${form.email}%0A`;
  if (form.phone) message += `*Phone:* ${form.phone}%0A`;
  if (form.company) message += `*Company:* ${form.company}%0A`;
  message += `*Subject:* ${subjectLabel}%0A`;
  message += `*Message:*%0A${form.message}%0A%0A`;
  message += `_Sent from Emmark Industries contact form_`;
  return message;
};

// ─── Main component ───────────────────────────────────────────────────────────
export default function Contact() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = "Full name is required.";
    if (!form.email.trim()) errs.email = "Email address is required.";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      errs.email = "Enter a valid email.";
    if (!form.subject) errs.subject = "Please select a subject.";
    if (!form.message.trim()) errs.message = "Message cannot be empty.";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setIsSending(true);
    const message = buildWhatsAppMessage(form);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");

    setForm(EMPTY_FORM);
    setSubmitted(true);
    setIsSending(false);
  };

  return (
    <div className="ecs-page-wrapper">
      {/* ── HERO SECTION ── */}
      <section className="ecs-hero">
        <div
          className="ecs-hero__bg"
        />
        <div className="ecs-hero__overlay" />
        <div className="ecs-hero__content">
          <div className="ecs-hero__pill">Get in Touch</div>
          <h1 className="ecs-hero__title">
            Let's Start a
            <br />
            <span className="ecs-hero__title-accent"> Conversation.</span>
          </h1>
          <p className="ecs-hero__sub">
            Reach out for inquiries, quotes, or technical support.
          </p>
          {/* <nav className="ecs-breadcrumb" aria-label="breadcrumb">
            <a href="/" className="ecs-breadcrumb__link">
              Home
            </a>
            <span className="ecs-breadcrumb__sep">/</span>
            <span className="ecs-breadcrumb__current">Contact</span>
          </nav> */}
        </div>
        <div className="ecs-hero__scroll-hint">scroll ↓</div>
      </section>

      {/* ── CONTENT SECTION ── */}
      <section id="contact" className="ecs-section">
        {/* ── Section header ── */}
        <div className="ecs-header">
          <span className="ecs-subtitle">Contact Us</span>
          <h2 className="ecs-title">Get In Touch</h2>
          <p className="ecs-tagline">
            Have questions or need a quote? We're here to help.
          </p>
        </div>

        {/* ── Two-column body ── */}
        <div className="ecs-body">
          {/* LEFT — contact info + map + director card */}
          <aside className="ecs-info-col">
            <div className="ecs-info-list">
              {CONTACT_ITEMS.map((item) => (
                <div key={item.id} className="ecs-info-item">
                  <div className="ecs-info-icon" aria-hidden="true">
                    {item.icon}
                  </div>
                  <div className="ecs-info-text">
                    <span className="ecs-info-label">{item.label}</span>
                    {item.href ? (
                      <a
                        href={item.href}
                        className="ecs-info-value ecs-info-link"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <span className="ecs-info-value">{item.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Director / Key Contact card */}
            <div className="ecs-director-card">
              {/* <div className="ecs-director-avatar" aria-hidden="true">
                RP
              </div> */}
              <div className="ecs-director-info">
                {/* <span className="ecs-director-name">Rama Prasad S</span> */}
                <span className="ecs-director-role">
                  Director — Technical &amp; Sales
                </span>
                <div className="ecs-director-contacts">
                  <a href="tel:+919495958871" className="ecs-director-link">
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .82h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                    </svg>
                    +91 9249535060
                  </a>
                  <a href="tel:+917907099782" className="ecs-director-link">
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .82h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                    </svg>
                    +91 9495958871
                  </a>
                  {/* <a
                    href="mailto:prasad@emmark.in"
                    className="ecs-director-link"
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                    prasad@emmark.in
                  </a> */}
                </div>
              </div>
              <div className="ecs-director-brand">
                <span className="ecs-director-brand-name">ARKLON</span>
                <span className="ecs-director-brand-tag">
                  Engineered for durability
                  <br />
                  Manufactured for performance
                </span>
              </div>
            </div>

            {/* Map embed */}
            <div className="ecs-map-wrapper">
              <iframe
                title="Emmark Industries Location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1215.8527976051062!2d76.7736592!3d10.7877644!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8697c2fd1dd95%3A0xbd4e403819041012!2sEmmark%20Industries!5e1!3m2!1sen!2sin!4v1771654482228!5m2!1sen!2sin"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </aside>

          {/* RIGHT — contact form */}
          <div className="ecs-form-col">
            {submitted ? (
              <div className="ecs-success">
                <div className="ecs-success-icon" aria-hidden="true">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                    <polyline points="22,4 12,14.01 9,11.01" />
                  </svg>
                </div>
                <h3 className="ecs-success-title">Message Prepared!</h3>
                <p className="ecs-success-desc">
                  WhatsApp will open so you can review and send the message.
                  We'll be in touch shortly.
                </p>
                <button
                  className="ecs-btn-reset"
                  onClick={() => setSubmitted(false)}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form
                className="ecs-form"
                id="ContactForm"
                onSubmit={handleSubmit}
                noValidate
              >
                <div className="ecs-form-grid">
                  {/* Full Name */}
                  <div className="ecs-field">
                    <label className="ecs-label" htmlFor="ecs-name">
                      Full Name <span className="ecs-required">*</span>
                    </label>
                    <input
                      id="ecs-name"
                      type="text"
                      name="name"
                      className={`ecs-input${errors.name ? " ecs-input--error" : ""}`}
                      placeholder="John Smith"
                      value={form.name}
                      onChange={handleChange}
                      autoComplete="name"
                    />
                    {errors.name && (
                      <span className="ecs-error">{errors.name}</span>
                    )}
                  </div>

                  {/* Email */}
                  <div className="ecs-field">
                    <label className="ecs-label" htmlFor="ecs-email">
                      Email Address <span className="ecs-required">*</span>
                    </label>
                    <input
                      id="ecs-email"
                      type="email"
                      name="email"
                      className={`ecs-input${errors.email ? " ecs-input--error" : ""}`}
                      placeholder="john@company.com"
                      value={form.email}
                      onChange={handleChange}
                      autoComplete="email"
                    />
                    {errors.email && (
                      <span className="ecs-error">{errors.email}</span>
                    )}
                  </div>

                  {/* Phone */}
                  <div className="ecs-field">
                    <label className="ecs-label" htmlFor="ecs-phone">
                      Phone Number
                    </label>
                    <input
                      id="ecs-phone"
                      type="tel"
                      name="phone"
                      className="ecs-input"
                      placeholder="+91 98765 43210"
                      value={form.phone}
                      onChange={handleChange}
                      autoComplete="tel"
                    />
                  </div>

                  {/* Company */}
                  <div className="ecs-field">
                    <label className="ecs-label" htmlFor="ecs-company">
                      Company Name
                    </label>
                    <input
                      id="ecs-company"
                      type="text"
                      name="company"
                      className="ecs-input"
                      placeholder="Acme Industries Ltd."
                      value={form.company}
                      onChange={handleChange}
                      autoComplete="organization"
                    />
                  </div>

                  {/* Subject — full width */}
                  <div className="ecs-field ecs-field--full">
                    <label className="ecs-label" htmlFor="ecs-subject">
                      Subject <span className="ecs-required">*</span>
                    </label>
                    <div className="ecs-select-wrapper">
                      <select
                        id="ecs-subject"
                        name="subject"
                        className={`ecs-select${errors.subject ? " ecs-input--error" : ""}`}
                        value={form.subject}
                        onChange={handleChange}
                      >
                        {SUBJECTS.map((s) => (
                          <option
                            key={s.value}
                            value={s.value}
                            disabled={s.value === ""}
                          >
                            {s.label}
                          </option>
                        ))}
                      </select>
                      <span className="ecs-select-arrow" aria-hidden="true">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </span>
                    </div>
                    {errors.subject && (
                      <span className="ecs-error">{errors.subject}</span>
                    )}
                  </div>

                  {/* Message — full width */}
                  <div className="ecs-field ecs-field--full">
                    <label className="ecs-label" htmlFor="ecs-message">
                      Message <span className="ecs-required">*</span>
                    </label>
                    <textarea
                      id="ecs-message"
                      name="message"
                      className={`ecs-textarea${errors.message ? " ecs-input--error" : ""}`}
                      placeholder="Tell us about your requirements, product specifications, or any questions you have..."
                      rows={5}
                      value={form.message}
                      onChange={handleChange}
                    />
                    {errors.message && (
                      <span className="ecs-error">{errors.message}</span>
                    )}
                  </div>

                  {/* Submit button — full width */}
                  <div className="ecs-field ecs-field--full">
                    <button
                      type="submit"
                      className="ecs-btn-submit"
                      disabled={isSending}
                      aria-busy={isSending}
                    >
                      {isSending ? (
                        <>
                          <span className="ecs-spinner" aria-hidden="true" />
                          Opening WhatsApp…
                        </>
                      ) : (
                        <>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <line x1="22" y1="2" x2="11" y2="13" />
                            <polygon points="22,2 15,22 11,13 2,9" />
                          </svg>
                          Send Message
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
